export { pointsValues };

const pointsValues = {
  GOOD_BUDGET_POINTS: 500,
  GOOD_BUDGET_MAX: 12,
  GOOD_BUDGET_MIN: 0,
  BAD_BUDGET_POINTS: -500,
  BAD_BUDGET_MAX: 0,
  CO2_POINTS: 500,
  CO2_MAX: 22,
  CO2_MIN: 0,
};
